module.exports = function getResource(label) {
    let resources = {
        seeTermsOfUse: 'Voir les conditions d’utilisation',
        noteText: 'Sauf mention contraire, toute information que vous fournissez sera intégrée à votre profil public lorsque vous soumettez un commentaire.',
        noteLabel: 'Remarque'
    };
    return resources[label];
};
